// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__cCJ5T","actionsCol":"EnrolledClinics_actionsCol__3W55x"};